<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row>
        <el-form-item :label="$l('from_label_department_code') || '部门编码'"
          prop="depNo">
          <el-input
            clearable
            v-model="formData.depNo"
            :placeholder="
              $l('from_label_ps_parameter_ID') ||
                '请输入部门编码'
            "
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('from_label_department_name') || '部门名称'"
          prop="depName"
        >
          <el-input
            clearable
            v-model="formData.depName"
            :placeholder="
              $l('from_label_ps_department_name') || '请输入部门名称'
            "
          >
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$l('from_radio_end_level') || '是否末级'">
            <el-col :span="24">
              <el-radio-group v-model="formData.isLast">
                <el-radio label="Y">{{
                  $l('from_radio_yes') || '是'
                }}</el-radio>
                <el-radio label="N">{{ $l('from_radio_no') || '否' }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('from_radio_valid_status') || '有效状态'"
            required
          >
            <el-col :span="24">
              <el-radio-group v-model="formData.depStatus">
                <el-radio label="Y">{{
                  $l('INDEX.form_label_valid') || '有效'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('INDEX.form_label_invalid') || '无效'
                }}</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    depCode: String,
    orgRow: {
      type: Object,
      default: () => {}
    },
    parentDep: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      regionShow: false,
      formData: { isLast: 'N', depStatus: 'Y' },
      rules: {
        depNo: [
          {
            required: true,
            message:
              this.$l('from_label_ps_parameter_ID') || '请输入部门编码',
            trigger: 'blur'
          }
        ],
        depName: [
          {
            required: true,
            message:
              this.$l('from_label_ps_department_name') || '请输入部门名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.depCode) return
      this.$api
        .sysDepartmentDetailApi({
          depCode: this.depCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      let params = { ...this.formData }
      if (!this.depCode) {
        const { depCode } = this.parentDep
        const { orgCode } = this.orgRow
        if (orgCode) {
          params = {
            ...this.formData,
            parentCode: orgCode,
            classLevel: 0,
            orgCode: orgCode
          }
        }
        if (depCode) {
          params = {
            ...this.formData,
            parentCode: depCode,
            classLevel: ++this.parentDep.classLevel,
            orgCode: this.parentDep.orgCode
          }
        }
      }
      this.loadingOpen()
      this.$api
        .sysDepartmentSaveApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success'
            })
            this.$emit('close')
            this.$emit('reload')
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          } else {
            return
          }
        })
    }
  }
}
</script>
